'use client';

import CoreIcon from '@woolworthslimited/core-components-react/icon/icon';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

import styles from './save-button.module.scss';
import { FeatureRecipeSaveButtonProps } from './save-button.types';

const FeatureRecipeSaveButton: React.FC<FeatureRecipeSaveButtonProps> = ({
  recipeId,
  recipeTitle,
  variation = 'default',
  isSaved = false,
  saveClickHandler,
  removeClickHandler,
}) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [recipeSaved, setRecipeSaved] = useState<boolean>(isSaved);

  useEffect(() => {
    setRecipeSaved(isSaved);
  }, [isSaved]);

  const saveButtonClickHandler = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsDisabled(true);
    try {
      const res = await saveClickHandler(recipeId);
      if (res) {
        setRecipeSaved((prev) => !prev);
      }
    } finally {
      setIsDisabled(false);
    }
  };

  const removeButtonClickHandler = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsDisabled(true);
    try {
      const res = await removeClickHandler(recipeId);
      if (res) {
        setRecipeSaved((prev) => !prev);
      }
    } finally {
      setIsDisabled(false);
    }
  };

  return recipeSaved ? (
    <button
      aria-label={`Remove ${recipeTitle} from saved recipes, button`}
      className={clsx(styles['recipe-save-button'], styles[`${variation}`], [
        styles['saved'],
      ])}
      disabled={isDisabled}
      onClick={removeButtonClickHandler}
    >
      <CoreIcon name={'icon-action-bookmark-fill'} ariaHidden={true} />
    </button>
  ) : (
    <button
      aria-label={`Save ${recipeTitle}, button`}
      className={clsx(styles['recipe-save-button'], styles[`${variation}`])}
      disabled={isDisabled}
      onClick={saveButtonClickHandler}
    >
      <CoreIcon name={'icon-action-bookmark'} ariaHidden={true} />
    </button>
  );
};

export default FeatureRecipeSaveButton;
